export default "__VITE_ASSET___JEjh67e__"